<template>
  <div class="flex items-center">
    <img v-if="icon" :src="icon" class="inline-block h-10" />
    <component
      class="hover-hover:hover:text-primary p-2 py-1"
      :is="external ? 'a' : 'router-link'"
      :target="{ _blank: external }"
      v-bind:[linkType]="navLink || $route.path"
      v-text="label"
    />
  </div>
</template>

<script>
import querystring from "querystring";
import _ from "lodash";
export default {
  props: {
    path: {
      type: String,
      default: null
    },
    external: Boolean,
    label: String,
    icon: String
  },
  computed: {
    navLink() {
      let link = this.path;
      let linkUrl = this.path && this.external ? new URL(this.path) : null;
      link = linkUrl ? linkUrl.origin + linkUrl.pathname : link;
      const prevQs = linkUrl && querystring.decode(linkUrl.search.slice(1));
      const qs = { ...this.$store.getters.trackers, ...prevQs };
      let params = querystring.encode(_.pickBy(qs, _.identity));
      return this.external ? `${link}${params && "?"}${params}` : link;
    },
    linkType() {
      return this.external ? "href" : "to";
    }
  }
};
</script>
